export interface NavItem {
  label: string;
  path: string;
  key: string;          // g-sequence second key
  testId: string;
}

export const NAV_ITEMS: NavItem[] = [
  { label: 'Dashboard',     path: '/dashboard',               key: 'd', testId: 'nav-dashboard' },
  { label: 'Risks',         path: '/risks',                   key: 'r', testId: 'nav-risks' },
  { label: 'Tasks',         path: '/tasks',                   key: 't', testId: 'nav-tasks' },
  { label: 'Reports',       path: '/ai-reports',              key: 'p', testId: 'nav-reports' },
  { label: 'Contacts',      path: '/contacts',                key: 'c', testId: 'nav-contacts' },
  { label: 'Organizations', path: '/organizations/companies', key: 'o', testId: 'nav-organizations' },
  { label: 'Settings',      path: '/settings',                key: 's', testId: 'nav-settings' },
];

export const MOBILE_TABS = ['Dashboard', 'Risks', 'Tasks'] as const; // + More
